import React from 'react';
import { withStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import { JSSClasses } from '../../proptypes/jss-prop-types';
import Modal from '../modal/Modal';
import withLocale from '../withLocale/withLocale';
import DangerousContent from '../dangerousContent/DangerousContent';

/* istanbul ignore next */
const styles = ({
  palette: {
    common: { white },
    primary: { normal },
    warning: { dark, light }
  },
  spacing: { unit },
  typography: {
    fontWeightHeavy,
    title: { fontSize }
  }
}) => ({
  content: {
    marginBottom: unit * 4,
    marginTop: unit
  },
  header: {
    display: 'flex',
    fontSize,
    '& b': {
      fontWeight: fontWeightHeavy
    }
  },
  headerStyles: {
    backgroundColor: light
  },
  icon: {
    color: dark,
    marginRight: unit * 2
  },
  // @TODO remove !important once glu modal react is in place
  gluButton: {
    backgroundColor: `${normal} !important`,
    color: `${white} !important`
  }
});

export function DynamicLink2Component({
  classes: { content, gluButton, header, headerStyles, icon },
  close,
  link,
  locale,
  show
}) {
  return (
    <Modal
      show={show}
      header={
        <header className={header}>
          <span className={`icon-exclamation-solid ${icon}`} />
          <DangerousContent content={locale['dynamicLink2.header']} />
        </header>
      }
      headerStyles={headerStyles}
      onHide={close}
    >
      <div className={content}>{locale['dynamicLink2.content']}</div>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={`btn btn-primary ${gluButton}`}
        onClick={close}
      >
        {locale['dynamicLink2.continue']}
      </a>
      <button className="btn btn-tertiary" onClick={close}>
        {locale['dynamicLink2.cancel']}
      </button>
    </Modal>
  );
}

DynamicLink2Component.propTypes = {
  classes: JSSClasses,
  close: PropTypes.func,
  link: PropTypes.string,
  locale: PropTypes.shape({}),
  show: PropTypes.bool
};

DynamicLink2Component.defaultProps = {
  classes: null,
  close() {},
  link: '',
  locale: {},
  show: false
};

const styled = withStyles(styles)(DynamicLink2Component);
const DynamicLink2 = withLocale(styled);
export default DynamicLink2;
